module.exports = __webpack_public_path__ + "static/media/item_8_14_comp.63f2e361.png";